import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h2 className="section-heading">Career History</h2>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2020 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Industrial Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Cetinay GmbH, Germany</h4>
            <p>
              Warehouse & Inventory Optimization, IFS Certification Processes, Quality Management, Personnel Processes, Basic Finance Processes, ISO Documentation, Capacity Planning, Cross-department Collaboration
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2016 - 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Aftersalesmanager</h3>
            <h4 className="vertical-timeline-element-subtitle">Jaguar, Land Rover, Turkey</h4>
            <p>
              Maintenance & Repair Optimization, Warranty & Spare Parts Management, Budget & Strategic Planning, Diagnostics & Software Updates, Technical Training, Customer Relationship Management, Quality Standards Implementation, International Supplier Collaboration
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2012 - 2016"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Aftersalesmanager</h3>
            <h4 className="vertical-timeline-element-subtitle">Fiat, Alfa Romeo, Lancia, Jeep, Turkey</h4>
            <p>
              Aftersales Operations Management, Maintenance & Spare Parts Processes, Cost Control & Workshop Optimization, Service Concept Development, Budgeting & Profitability Analysis, Team Leadership & Training, International Brand Collaboration, Quality Standards Assurance
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2004 - 2012"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Aftersalesmanager</h3>
            <h4 className="vertical-timeline-element-subtitle">VW, Audi, Turkey</h4>
            <p>
              Aftersales Process Management, Maintenance & Repair Standardization, Warranty & Spare Parts Control, Budget Planning & Cost Analysis, Service Team Leadership, Quality & Service Program Implementation
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;